import { keepPreviousData, useQuery } from '@tanstack/react-query';

import getPresenceHistory from 'Api/host-presence-content/getPresenceHistory';
import getPresenceHistoryRequest from './model/request/getPresenceHistoryRequest';
import getPresenceHistoryResponse from './model/response/useGetPresenceHistory.Response';

import { useHostPresenceContentState } from 'View/host-presence-content/state';

const useGetPresenceHistory = ({ params }) => {
  const { state, updateState } = useHostPresenceContentState();

  return useQuery({
    queryKey: ['host-presence-history', params],
    queryFn: async () => {
      const queries = getPresenceHistoryRequest(params);

      const response = await getPresenceHistory(queries);

      const result = getPresenceHistoryResponse(response, state.previousPresenceHistory, params?.page);

      updateState({ previousPresenceHistory: result?.presences });

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    placeholderData: keepPreviousData,
  });
};

export default useGetPresenceHistory;
